/**
 * Rectangular banner at the top of the screen, which displays alerts and errors
 * to the user. It utilizes the vx_library to render a small warning icon followed
 * by the warning message.
 */

import PropTypes from 'prop-types'

import React from 'react'

// load content
import content from 'pp-react-l10n'
let i18n = content('crossBorder/calc')

class Banner extends React.Component {
  static propTypes = {
    error: PropTypes.shape({
      message: PropTypes.string,
    }),
    level: PropTypes.oneOf(['help', 'success', 'warning', 'critical']),
  }

  static defaultProps = { level: 'warning' }

  render() {
    const { error, level } = this.props

    // if no error, do not render the banner
    if (!error) {
      return null
    }

    // pull the message off the error object, default to generic content
    const message = error.message || i18n('error.generic')

    const css = {
      margin: '0 auto 25px',
      maxWidth: '680px',
      padding: '1em',
    }

    return (
      <div className={`vx_alert vx_alert-${level}`} style={css}>
        <p className="vx_alert-text">{message}</p>
      </div>
    )
  }
}

export default Banner
